import { usePhotoUploads } from '@/components/PhotoUploads';
import type { PhotoRow } from '@/schema/estate';
import { type PhotoState, photoState } from '@/services/uploadStatus';

export function usePhotoState(photo: PhotoRow): PhotoState {
  return photoState(photo, usePhotoUploads().stateOf(photo.id));
}
